"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.guideListNormalizer = void 0;
const mocks_json_1 = __importDefault(require("./mocks.json"));
/**
 * normalizador del modulo MODULO_CARACTERISTIC_CARDS
 * @param {object} fields
 * @returns
 */
const guideListNormalizer = (data) => {
    let res = null;
    try {
        if (data) {
            const { fields } = data;
            if (fields) {
                const mainTitle = fields.title;
                const titleFaq = fields.titleFaq;
                const ancla = fields.ancla;
                const link = fields.href || fields.link;
                const listadoCharacs = fields.caracteristicsList;
                if (listadoCharacs &&
                    Array.isArray(listadoCharacs) &&
                    listadoCharacs.length > 0) {
                    const normalizedInfo = {};
                    normalizedInfo.component = "guideList";
                    if (mainTitle) {
                        normalizedInfo["Text-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-1"]), { text: mainTitle });
                    }
                    if (titleFaq) {
                        normalizedInfo["Text-2"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-2"]), { text: titleFaq });
                    }
                    if (ancla) {
                        normalizedInfo["CustomLink-1"] = Object.assign(Object.assign({}, mocks_json_1.default["CustomLink-1"]), { href: link || "", title: ancla || "" });
                    }
                    listadoCharacs.map((carach, index) => {
                        const { fields } = carach;
                        const { title, subTitle, description } = fields;
                        const card = {};
                        if (title) {
                            card["Text-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Charac"]["Text-1"]), { text: title });
                        }
                        if (subTitle || description) {
                            card["Text-2"] = Object.assign(Object.assign({}, mocks_json_1.default["Charac"]["Text-2"]), { text: subTitle || description });
                        }
                        const hasItems = Object.keys(card).length > 0;
                        if (hasItems) {
                            normalizedInfo[`Charac-${index}`] = card;
                        }
                        res = normalizedInfo;
                    });
                }
            }
        }
        return res;
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
exports.guideListNormalizer = guideListNormalizer;
exports.default = exports.guideListNormalizer;
//# sourceMappingURL=index.js.map